import "./NonStatutoryBodies.scss";
import { Outlet } from 'react-router-dom';

const NonStatutoryBodies = () => {
    return (
        <>
            <Outlet />
        </>
    )
}

export default NonStatutoryBodies
